export const PARAMETER_TRANSLATION_KEYS = {
  SHARED: {
    ASPECT_RATIO: {
      TITLE: 'PARAMETER_TRANSLATIONS_SHARED_ASPECT_RATIO_TITLE',
    },
    SEED: {
      TITLE: 'PARAMETER_TRANSLATIONS_SHARED_SEED_TITLE',
      DESCRIPTION: 'PARAMETER_TRANSLATIONS_SHARED_SEED_DESCRIPTION',
    },
  },

  MUXV2: {
    OPTIONS: {
      TITLE: 'PARAMETER_TRANSLATIONS_MUXV2_OPTIONS_TITLE',
      DESCRIPTION: 'PARAMETER_TRANSLATIONS_MUXV2_OPTIONS_DESCRIPTION',
    },
  },
  MASKS: {
    FEATHER: {
      TITLE: 'PARAMETER_TRANSLATIONS_MASKS_FEATHER_TITLE',
      DESCRIPTION: 'PARAMETER_TRANSLATIONS_MASKS_FEATHER_DESCRIPTION',
    },
    MATTE_CHOKER: {
      TITLE: 'PARAMETER_TRANSLATIONS_MASKS_MATTE_CHOKER_TITLE',
      DESCRIPTION: 'PARAMETER_TRANSLATIONS_MASKS_MATTE_CHOKER_DESCRIPTION',
    },
    INVERT: {
      TITLE: 'PARAMETER_TRANSLATIONS_MASKS_INVERT_TITLE',
      DESCRIPTION: 'PARAMETER_TRANSLATIONS_MASKS_INVERT_DESCRIPTION',
    },
  },
  MODELS: {
    MINIMAX_IMAGE01: {
      NUMBER_OF_IMAGES: {
        TITLE: 'PARAMETER_TRANSLATIONS_MINIMAX_IMAGE01_NUMBER_OF_IMAGES_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_MINIMAX_IMAGE01_NUMBER_OF_IMAGES_DESCRIPTION',
      },
      ASPECT_RATIO: {
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_MINIMAX_IMAGE01_ASPECT_RATIO_DESCRIPTION',
      },
      PROMPT_OPTIMIZER: {
        TITLE: 'PARAMETER_TRANSLATIONS_MINIMAX_IMAGE01_PROMPT_OPTIMIZER_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_MINIMAX_IMAGE01_PROMPT_OPTIMIZER_DESCRIPTION',
      },
    },
    REVE: {
      ASPECT_RATIO: {
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_REVE_ASPECT_RATIO_DESCRIPTION',
      },
    },
    IMAGEN3: {
      ASPECT_RATIO: {
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_IMAGEN3_ASPECT_RATIO_DESCRIPTION',
      },
    },
    WAN_VIDEO: {
      ASPECT_RATIO: {
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_WAN_VIDEO_ASPECT_RATIO_DESCRIPTION',
      },
      FRAME_NUM: {
        TITLE: 'PARAMETER_TRANSLATIONS_WAN_VIDEO_FRAME_NUM_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_WAN_VIDEO_FRAME_NUM_DESCRIPTION',
      },
      RESOLUTION: {
        TITLE: 'PARAMETER_TRANSLATIONS_WAN_VIDEO_RESOLUTION_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_WAN_VIDEO_RESOLUTION_DESCRIPTION',
      },
      SAMPLE_STEPS: {
        TITLE: 'PARAMETER_TRANSLATIONS_WAN_VIDEO_SAMPLE_STEPS_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_WAN_VIDEO_SAMPLE_STEPS_DESCRIPTION',
      },
      SAMPLE_GUIDE_SCALE: {
        TITLE: 'PARAMETER_TRANSLATIONS_WAN_VIDEO_SAMPLE_GUIDE_SCALE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_WAN_VIDEO_SAMPLE_GUIDE_SCALE_DESCRIPTION',
      },
      SAMPLE_SHIFT: {
        TITLE: 'PARAMETER_TRANSLATIONS_WAN_VIDEO_SAMPLE_SHIFT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_WAN_VIDEO_SAMPLE_SHIFT_DESCRIPTION',
      },
    },
    BR_BGREPLACE: {
      FAST: {
        TITLE: 'PARAMETER_TRANSLATIONS_BR_BGREPLACE_FAST_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_BR_BGREPLACE_FAST_DESCRIPTION',
      },
      REFINE_PROMPT: {
        TITLE: 'PARAMETER_TRANSLATIONS_BR_BGREPLACE_REFINE_PROMPT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_BR_BGREPLACE_REFINE_PROMPT_DESCRIPTION',
      },
      ORIGINAL_QUALITY: {
        TITLE: 'PARAMETER_TRANSLATIONS_BR_BGREPLACE_ORIGINAL_QUALITY_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_BR_BGREPLACE_ORIGINAL_QUALITY_DESCRIPTION',
      },
    },
    LUMA_PHOTON: {
      ASPECT_RATIO: {
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_LUMA_PHOTON_ASPECT_RATIO_DESCRIPTION',
      },
      IMAGE_REFERENCE_WEIGHT: {
        TITLE: 'PARAMETER_TRANSLATIONS_LUMA_PHOTON_IMAGE_REFERENCE_WEIGHT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_LUMA_PHOTON_IMAGE_REFERENCE_WEIGHT_DESCRIPTION',
      },
      STYLE_REFERENCE_WEIGHT: {
        TITLE: 'PARAMETER_TRANSLATIONS_LUMA_PHOTON_STYLE_REFERENCE_WEIGHT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_LUMA_PHOTON_STYLE_REFERENCE_WEIGHT_DESCRIPTION',
      },
    },
    FLUX_FAST: {
      ASPECT_RATIO: {
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_FAST_ASPECT_RATIO_DESCRIPTION',
      },
      GUIDANCE: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_FAST_GUIDANCE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_FAST_GUIDANCE_DESCRIPTION',
      },
      OUTPUT_FORMAT: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_FAST_OUTPUT_FORMAT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_FAST_OUTPUT_FORMAT_DESCRIPTION',
      },
      OUTPUT_QUALITY: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_FAST_OUTPUT_QUALITY_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_FAST_OUTPUT_QUALITY_DESCRIPTION',
      },
    },
    FLUX_CANNY_PRO: {
      SEED: {
        TITLE: 'PARAMETER_TRANSLATIONS_SHARED_SEED_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_CANNY_PRO_SEED_DESCRIPTION',
      },
      STEPS: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_CANNY_PRO_STEPS_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_CANNY_PRO_STEPS_DESCRIPTION',
      },
      PROMPT_UPSAMPLING: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_CANNY_PRO_PROMPT_UPSAMPLING_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_CANNY_PRO_PROMPT_UPSAMPLING_DESCRIPTION',
      },
      GUIDANCE: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_CANNY_PRO_GUIDANCE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_CANNY_PRO_GUIDANCE_DESCRIPTION',
      },
      SAFETY_TOLERANCE: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_CANNY_PRO_SAFETY_TOLERANCE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_CANNY_PRO_SAFETY_TOLERANCE_DESCRIPTION',
      },
      OUTPUT_FORMAT: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_CANNY_PRO_OUTPUT_FORMAT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_CANNY_PRO_OUTPUT_FORMAT_DESCRIPTION',
      },
    },
    FLUX_DEPTH_PRO: {
      SEED: {
        TITLE: 'PARAMETER_TRANSLATIONS_SHARED_SEED_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_DEPTH_PRO_SEED_DESCRIPTION',
      },
      STEPS: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_DEPTH_PRO_STEPS_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_DEPTH_PRO_STEPS_DESCRIPTION',
      },
      PROMPT_UPSAMPLING: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_DEPTH_PRO_PROMPT_UPSAMPLING_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_DEPTH_PRO_PROMPT_UPSAMPLING_DESCRIPTION',
      },
      GUIDANCE: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_DEPTH_PRO_GUIDANCE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_DEPTH_PRO_GUIDANCE_DESCRIPTION',
      },
      SAFETY_TOLERANCE: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_DEPTH_PRO_SAFETY_TOLERANCE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_DEPTH_PRO_SAFETY_TOLERANCE_DESCRIPTION',
      },
      OUTPUT_FORMAT: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_DEPTH_PRO_OUTPUT_FORMAT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_DEPTH_PRO_OUTPUT_FORMAT_DESCRIPTION',
      },
    },
    FLUX_REDUX_DEV: {
      ASPECT_RATIO: {
        TITLE: 'PARAMETER_TRANSLATIONS_SHARED_ASPECT_RATIO_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_ASPECT_RATIO_DESCRIPTION',
      },
      NUM_OUTPUTS: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_NUM_OUTPUTS_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_NUM_OUTPUTS_DESCRIPTION',
      },
      NUM_INFERENCE_STEPS: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_NUM_INFERENCE_STEPS_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_NUM_INFERENCE_STEPS_DESCRIPTION',
      },
      GUIDANCE: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_GUIDANCE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_GUIDANCE_DESCRIPTION',
      },
      SEED: {
        TITLE: 'PARAMETER_TRANSLATIONS_SHARED_SEED_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_SEED_DESCRIPTION',
      },
      OUTPUT_FORMAT: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_OUTPUT_FORMAT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_OUTPUT_FORMAT_DESCRIPTION',
      },
      OUTPUT_QUALITY: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_OUTPUT_QUALITY_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_OUTPUT_QUALITY_DESCRIPTION',
      },
      DISABLE_SAFETY_CHECKER: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_DISABLE_SAFETY_CHECKER_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_DISABLE_SAFETY_CHECKER_DESCRIPTION',
      },
      MEGAPIXELS: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_MEGAPIXELS_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_REDUX_DEV_MEGAPIXELS_DESCRIPTION',
      },
    },
    GPT_IMAGE_1: {
      MODEL: {
        TITLE: 'PARAMETER_TRANSLATIONS_GPT_IMAGE_1_MODEL_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_GPT_IMAGE_1_MODEL_DESCRIPTION',
      },
      SIZE: {
        TITLE: 'PARAMETER_TRANSLATIONS_GPT_IMAGE_1_SIZE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_GPT_IMAGE_1_SIZE_DESCRIPTION',
      },
      QUALITY: {
        TITLE: 'PARAMETER_TRANSLATIONS_GPT_IMAGE_1_QUALITY_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_GPT_IMAGE_1_QUALITY_DESCRIPTION',
      },
      BACKGROUND: {
        TITLE: 'PARAMETER_TRANSLATIONS_GPT_IMAGE_1_BACKGROUND_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_GPT_IMAGE_1_BACKGROUND_DESCRIPTION',
      },
    },

    ANY_LLM: {
      MODEL: {
        TITLE: 'PARAMETER_TRANSLATIONS_ANY_LLM_MODEL_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_ANY_LLM_MODEL_DESCRIPTION',
      },
      TEMPERATURE: {
        TITLE: 'PARAMETER_TRANSLATIONS_ANY_LLM_TEMPERATURE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_ANY_LLM_TEMPERATURE_DESCRIPTION',
      },
      THINKING: {
        TITLE: 'PARAMETER_TRANSLATIONS_ANY_LLM_THINKING_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_ANY_LLM_THINKING_DESCRIPTION',
      },
    },

    IMAGE_DESCRIBER: {
      PROMPT: {
        TITLE: 'PARAMETER_TRANSLATIONS_IMAGE_DESCRIBER_PROMPT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_IMAGE_DESCRIBER_PROMPT_DESCRIPTION',
      },
    },

    PROMPT_ENHANCER: {
      SYSTEM_PROMPT: {
        TITLE: 'PARAMETER_TRANSLATIONS_PROMPT_ENHANCER_SYSTEM_PROMPT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_PROMPT_ENHANCER_SYSTEM_PROMPT_DESCRIPTION',
      },
    },

    SD_SKETCH: {
      CONTROL_STRENGTH: {
        TITLE: 'PARAMETER_TRANSLATIONS_SD_SKETCH_CONTROL_STRENGTH_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_SD_SKETCH_CONTROL_STRENGTH_DESCRIPTION',
      },
      CONTROL_TYPE: {
        TITLE: 'PARAMETER_TRANSLATIONS_SD_SKETCH_CONTROL_TYPE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_SD_SKETCH_CONTROL_TYPE_DESCRIPTION',
      },
    },
    MINIMAX_VIDEO_DIRECTOR: {
      PROMPT_OPTIMIZER: {
        TITLE: 'PARAMETER_TRANSLATIONS_MINIMAX_VIDEO_DIRECTOR_PROMPT_OPTIMIZER_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_MINIMAX_VIDEO_DIRECTOR_PROMPT_OPTIMIZER_DESCRIPTION',
      },
    },
    MESHY: {
      SURFACE_MODE: {
        TITLE: 'PARAMETER_TRANSLATIONS_MESHY_SURFACE_MODE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_MESHY_SURFACE_MODE_DESCRIPTION',
      },
    },
    HUNYUAN3D: {
      STEPS: {
        TITLE: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_STEPS_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_STEPS_DESCRIPTION',
      },
      GUIDANCE_SCALE: {
        TITLE: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_GUIDANCE_SCALE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_GUIDANCE_SCALE_DESCRIPTION',
      },
      RANDOMIZE_SEED: {
        TITLE: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_RANDOMIZE_SEED_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_RANDOMIZE_SEED_DESCRIPTION',
      },
      OCTREE_RESOLUTION: {
        TITLE: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_OCTREE_RESOLUTION_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_OCTREE_RESOLUTION_DESCRIPTION',
      },
      REMOVE_BACKGROUND: {
        TITLE: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_REMOVE_BACKGROUND_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_REMOVE_BACKGROUND_DESCRIPTION',
      },
      NUM_CHUNKS: {
        TITLE: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_NUM_CHUNKS_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_NUM_CHUNKS_DESCRIPTION',
      },
      TARGET_FACE_NUM: {
        TITLE: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_TARGET_FACE_NUM_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_HUNYUAN3D_TARGET_FACE_NUM_DESCRIPTION',
      },
    },
    FLUX_11_PRO: {
      ASPECT_RATIO: {
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_ASPECT_RATIO_DESCRIPTION',
      },
      WIDTH: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_WIDTH_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_WIDTH_DESCRIPTION',
      },
      HEIGHT: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_HEIGHT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_HEIGHT_DESCRIPTION',
      },
      SAFETY_TOLERANCE: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_SAFETY_TOLERANCE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_SAFETY_TOLERANCE_DESCRIPTION',
      },
      PROMPT_UPSAMPLING: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_PROMPT_UPSAMPLING_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_PROMPT_UPSAMPLING_DESCRIPTION',
      },
      OUTPUT_FORMAT: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_OUTPUT_FORMAT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_OUTPUT_FORMAT_DESCRIPTION',
      },
      OUTPUT_QUALITY: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_OUTPUT_QUALITY_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_OUTPUT_QUALITY_DESCRIPTION',
      },
    },
    FLUX_11_PRO_ULTRA: {
      IMAGE_PROMPT_STRENGTH: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_ULTRA_IMAGE_PROMPT_STRENGTH_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_ULTRA_IMAGE_PROMPT_STRENGTH_DESCRIPTION',
      },
      ASPECT_RATIO: {
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_ULTRA_ASPECT_RATIO_DESCRIPTION',
      },
      SAFETY_TOLERANCE: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_ULTRA_SAFETY_TOLERANCE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_ULTRA_SAFETY_TOLERANCE_DESCRIPTION',
      },
      RAW: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_ULTRA_RAW_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_ULTRA_RAW_DESCRIPTION',
      },
      OUTPUT_FORMAT: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_ULTRA_OUTPUT_FORMAT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_11_PRO_ULTRA_OUTPUT_FORMAT_DESCRIPTION',
      },
    },
    FLUX_KONTEXT: {
      MODEL: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_KONTEXT_MODEL_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_KONTEXT_MODEL_DESCRIPTION',
      },
      ASPECT_RATIO: {
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_KONTEXT_ASPECT_RATIO_DESCRIPTION',
      },
      NUM_INFERENCE_STEPS: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_KONTEXT_NUM_INFERENCE_STEPS_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_KONTEXT_NUM_INFERENCE_STEPS_DESCRIPTION',
      },
      GUIDANCE_SCALE: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_KONTEXT_GUIDANCE_SCALE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_KONTEXT_GUIDANCE_SCALE_DESCRIPTION',
      },
      OUTPUT_FORMAT: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_KONTEXT_OUTPUT_FORMAT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_KONTEXT_OUTPUT_FORMAT_DESCRIPTION',
      },
    },
    FLUX_KONTEXT_MULTI_IMAGE: {
      ASPECT_RATIO: {
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_KONTEXT_MULTI_IMAGE_ASPECT_RATIO_DESCRIPTION',
      },
      OUTPUT_FORMAT: {
        TITLE: 'PARAMETER_TRANSLATIONS_FLUX_KONTEXT_MULTI_IMAGE_OUTPUT_FORMAT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_FLUX_KONTEXT_MULTI_IMAGE_OUTPUT_FORMAT_DESCRIPTION',
      },
    },
    TOPAZ_IMAGE_SHARPEN: {
      MODEL: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_SHARPEN_MODEL_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_SHARPEN_MODEL_DESCRIPTION',
      },
      OUTPUT_FORMAT: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_SHARPEN_OUTPUT_FORMAT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_SHARPEN_OUTPUT_FORMAT_DESCRIPTION',
      },
      SUBJECT_DETECTION: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_SHARPEN_SUBJECT_DETECTION_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_SHARPEN_SUBJECT_DETECTION_DESCRIPTION',
      },
      FACE_ENHANCEMENT: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_SHARPEN_FACE_ENHANCEMENT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_SHARPEN_FACE_ENHANCEMENT_DESCRIPTION',
      },
      FACE_ENHANCEMENT_CREATIVITY: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_SHARPEN_FACE_ENHANCEMENT_CREATIVITY_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_SHARPEN_FACE_ENHANCEMENT_CREATIVITY_DESCRIPTION',
      },
      FACE_ENHANCEMENT_STRENGTH: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_SHARPEN_FACE_ENHANCEMENT_STRENGTH_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_SHARPEN_FACE_ENHANCEMENT_STRENGTH_DESCRIPTION',
      },
    },
    TOPAZ_IMAGE_UPSCALE: {
      MODEL: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_MODEL_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_MODEL_DESCRIPTION',
      },
      UPSCALE_FACTOR: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_UPSCALE_FACTOR_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_UPSCALE_FACTOR_DESCRIPTION',
      },
      CROP_TO_FILL: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_CROP_TO_FILL_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_CROP_TO_FILL_DESCRIPTION',
      },
      FACE_ENHANCEMENT: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_FACE_ENHANCEMENT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_FACE_ENHANCEMENT_DESCRIPTION',
      },
      SUBJECT_DETECTION: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_SUBJECT_DETECTION_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_SUBJECT_DETECTION_DESCRIPTION',
      },
      FACE_ENHANCEMENT_STRENGTH: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_FACE_ENHANCEMENT_STRENGTH_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_FACE_ENHANCEMENT_STRENGTH_DESCRIPTION',
      },
      FACE_ENHANCEMENT_CREATIVITY: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_FACE_ENHANCEMENT_CREATIVITY_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_FACE_ENHANCEMENT_CREATIVITY_DESCRIPTION',
      },
      OUTPUT_FORMAT: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_OUTPUT_FORMAT_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_OUTPUT_FORMAT_DESCRIPTION',
      },
      SHARPEN: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_SHARPEN_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_SHARPEN_DESCRIPTION',
      },
      DENOISE: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_DENOISE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_DENOISE_DESCRIPTION',
      },
      FIX_COMPRESSION: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_FIX_COMPRESSION_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_FIX_COMPRESSION_DESCRIPTION',
      },
      STRENGTH: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_STRENGTH_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_STRENGTH_DESCRIPTION',
      },
      CREATIVITY: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_CREATIVITY_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_CREATIVITY_DESCRIPTION',
      },
      TEXTURE: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_TEXTURE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_TEXTURE_DESCRIPTION',
      },
      DETAIL: {
        TITLE: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_DETAIL_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_TOPAZ_IMAGE_UPSCALE_DETAIL_DESCRIPTION',
      },
    },
    KLING: {
      MODEL: {
        TITLE: 'PARAMETER_TRANSLATIONS_KLING_MODEL_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_KLING_MODEL_DESCRIPTION',
      },
      DURATION: {
        TITLE: 'PARAMETER_TRANSLATIONS_KLING_DURATION_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_KLING_DURATION_DESCRIPTION',
      },
      CFG_SCALE: {
        TITLE: 'PARAMETER_TRANSLATIONS_KLING_CFG_SCALE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_KLING_CFG_SCALE_DESCRIPTION',
      },
      SHOT_TYPE: {
        TITLE: 'PARAMETER_TRANSLATIONS_KLING_SHOT_TYPE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_KLING_SHOT_TYPE_DESCRIPTION',
      },
      ASPECT_RATIO: {
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_KLING_ASPECT_RATIO_DESCRIPTION',
      },
      GENERATE_AUDIO: {
        TITLE: 'PARAMETER_TRANSLATIONS_KLING_GENERATE_AUDIO_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_KLING_GENERATE_AUDIO_DESCRIPTION',
      },
      RESOLUTION: {
        TITLE: 'PARAMETER_TRANSLATIONS_KLING_RESOLUTION_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_KLING_RESOLUTION_DESCRIPTION',
      },
    },
    ELEVEN_LABS_VOICE_CHANGER: {
      VOICE: {
        TITLE: 'PARAMETER_TRANSLATIONS_ELEVEN_LABS_VOICE_CHANGER_VOICE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_ELEVEN_LABS_VOICE_CHANGER_VOICE_DESCRIPTION',
      },
      REMOVE_BACKGROUND_NOISE: {
        TITLE: 'PARAMETER_TRANSLATIONS_ELEVEN_LABS_VOICE_CHANGER_REMOVE_BACKGROUND_NOISE_TITLE',
        DESCRIPTION: 'PARAMETER_TRANSLATIONS_ELEVEN_LABS_VOICE_CHANGER_REMOVE_BACKGROUND_NOISE_DESCRIPTION',
      },
    },
  },
};
